import React from "react";
import { useSelector } from "react-redux";
import Widget from "../../../../shared/components/features/widget/Widget";
import NavigateLink from "../../../../shared/components/features/navigateLink/navigateLink";
import finalProjectPortal from "../../../../assests/finalProjectPortal.png"
import classes from "./FinalProjectPortalWidget.module.css";

const FinalProjectPortalWidget = () => {

    const { texts } = useSelector(state => state.translate);
    const general = useSelector(state => state.uiData?.general);

    return (
        <NavigateLink link={general?.FinalProject?.portalStudentLink}>
            <Widget
                color="#F2F4F6"
                className={classes.FinalProjectPortalWidget}
                title={texts.finalProjectPortal}
                contentScrollable={false}
            >
                <div className={classes.PortalContent}>
                    <img src={finalProjectPortal} className={classes.PortalImg} alt="" />
                    <span className={classes.MobilePortalTitle}>{texts.finalProjectPortal}</span>
                    <div className={classes.PortalText}>
                        <span className={classes.PortalTextTitle}>{texts.finalProjectPortalText}</span>
                        {texts.finalProjectPortalText2}
                    </div>
                </div>
            </Widget>
        </NavigateLink>
    );
};

export default FinalProjectPortalWidget;

